(function () {

  if (window.__atcGlobalInit) return;
  window.__atcGlobalInit = true;

  var pendingVariants = {};
  var selfDispatching = false;

  function getLabel(el) {
    return el.querySelector('span:first-child');
  }

  function getVariantButtons(variantId) {
    return document.querySelectorAll(
      '[data-variant="' + variantId + '"]'
    );
  }

  function setDisabled(btn, state) {
    if (btn.tagName === 'A') {
      btn.classList.toggle('is-disabled', state);

      if (state) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    } else {
      btn.disabled = state;
    }
  }

  function isDisabled(btn) {
    return btn.tagName === 'A'
      ? btn.classList.contains('is-disabled')
      : btn.disabled;
  }

  function updateButtonState(btn, inCart, availableQty) {
    var label = getLabel(btn);

    if (!label) return;

    var fullyMaxed =
      availableQty === 0 ||
      (availableQty > 0 && inCart >= availableQty);

    label.textContent = fullyMaxed
      ? (btn.dataset.soldLabel || 'SOLD OUT')
      : (btn.dataset.addLabel || 'ADD TO CART');

    setDisabled(btn, fullyMaxed);
  }

  function syncVariantButtonsFromCart(variantId, cart) {
    getVariantButtons(variantId).forEach(function (btn) {

      var availableQty = parseInt(btn.dataset.available);

      if (isNaN(availableQty)) return;

      var inCart = 0;

      cart.items.forEach(function (item) {
        if (item.variant_id == variantId) {
          inCart = item.quantity;
        }
      });

      updateButtonState(btn, inCart, availableQty);
    });
  }

  function syncButtonWithCart(btn) {
    var variantId = parseInt(btn.dataset.variant);
    var availableQty = parseInt(btn.dataset.available);

    if (isNaN(availableQty)) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {

        var inCart = 0;

        cart.items.forEach(function (item) {
          if (item.variant_id == variantId) {
            inCart = item.quantity;
          }
        });

        getVariantButtons(variantId).forEach(function (button) {
          updateButtonState(button, inCart, availableQty);
        });
      });
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-variant]').forEach(function (btn) {
      syncButtonWithCart(btn);
    });
  }

  function updateCartBubble(count) {
    var bubble = document.querySelector('[ref="cartBubbleCount"]');

    if (bubble) {
      bubble.textContent = count;
    }
  }

  function addToCart(variantId, qty, availableQty) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {

        var existing = 0;

        cart.items.forEach(function (item) {
          if (item.variant_id == variantId) {
            existing = item.quantity;
          }
        });

        if (
          !isNaN(availableQty) &&
          (existing + qty) > availableQty
        ) {
          throw new Error('max_quantity');
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: qty
          })
        });
      })
      .then(function (response) {

        if (!response.ok) {
          throw new Error('add_failed');
        }

        return response.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (r) {
        return r.json();
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAllButtons();
  });

  document.addEventListener('cart:update', function () {

    if (selfDispatching) return;

    syncAllButtons();
  });

  document.addEventListener('click', function (e) {

    var btn = e.target.closest('[data-variant]');

    if (!btn) return;

    e.preventDefault();

    var variantId = btn.dataset.variant;

    if (pendingVariants[variantId]) {
      return;
    }

    if (isDisabled(btn)) {
      return;
    }

    var qty = parseInt(btn.dataset.qty) || 1;
    var availableQty = parseInt(btn.dataset.available);

    pendingVariants[variantId] = true;

    getVariantButtons(variantId).forEach(function (button) {

      setDisabled(button, true);

      var label = getLabel(button);

      if (label) {
        label.textContent = 'Adding...';
      }
    });

    addToCart(variantId, qty, availableQty)

      .then(function (cart) {

        delete pendingVariants[variantId];

        syncVariantButtonsFromCart(variantId, cart);

        updateCartBubble(cart.item_count);

        selfDispatching = true;

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {
                item_count: cart.item_count
              },
              data: {
                itemCount: cart.item_count
              }
            }
          })
        );

        selfDispatching = false;
      })

      .catch(function (err) {

        delete pendingVariants[variantId];

        if (err.message === 'max_quantity') {

          getVariantButtons(variantId).forEach(function (button) {

            var label = getLabel(button);

            if (label) {
              label.textContent = 'Max qty reached';
            }
          });

          setTimeout(function () {
            syncAllButtons();
          }, 2000);

        } else {

          syncAllButtons();
        }
      });
  });

})();